import { InjectionToken } from '@angular/core';
import { BaseProductService } from '../+products/-base-product.service';
import { BaseProductStateModel } from '../+products/base-product-state.models';

export const serviceFactoryInjectToken = new InjectionToken<IServiceFactoryService>('service-factory-token');

export interface IServiceFactoryService {
    getProductService(productName: string): BaseProductService<BaseProductStateModel>;
}
